function triggerMdContentScroll() {
	var elems = angular.element("[onscroll]");
	for (var i = 0; i < elems.length; i++) {
		var elem = elems[i];
		var os = elem.attributes["onscroll"];
		if (!os) {
			return;
		}
		if (os.value.indexOf("onMdContentScroll") != 0) {
			return;
		}

		onMdContentScroll(null, elem);
	}
}

function onMdContentScroll(evt, orTarget) {
	var target;

	if (evt) {
		target = evt.target;
	}
	if (orTarget) {
		target = orTarget;
	}

	if (target.className.indexOf("autofade") === -1) {
		return;
	}

	var totalHeight = target.scrollHeight;
	var scrollTop = target.scrollTop;
	var containerHeight = target.clientHeight;
	var scrollBottom = totalHeight - scrollTop - containerHeight;

	var scrollDelta = totalHeight - containerHeight;
	var pct = 0.0;
	// Only calculate this for scrollDelta > 0, not scrollDelta == 0.
	// Otherwise we'll divide by zero. Also, scrollDelta == 0 means that
	// we don't scroll at all, so our percentage should be 0%.
	if (scrollDelta > 0) {
		pct = (scrollBottom*4) / scrollDelta;
	}

	var cls = target.className.split(" ");

	// Find original classNames.
	var asdf = [];
	for (var i = 0; i < cls.length; i++) {
		var kls = cls[i];
		if (cls[i].indexOf("__mdfade") === 0) {
			continue;
		}
		asdf.push(cls[i]);
	}

	if (pct >= 0.99) {
		target.className = asdf.join(" ") + " __mdfade_bottom_100";
	} else if (pct >= 0.9) {
		target.className = asdf.join(" ") + " __mdfade_bottom_90";
	} else if (pct >= 0.8) {
		target.className = asdf.join(" ") + " __mdfade_bottom_80";
	} else if (pct >= 0.7) {
		target.className = asdf.join(" ") + " __mdfade_bottom_70";
	} else if (pct >= 0.6) {
		target.className = asdf.join(" ") + " __mdfade_bottom_60";
	} else if (pct >= 0.5) {
		target.className = asdf.join(" ") + " __mdfade_bottom_50";
	} else if (pct >= 0.4) {
		target.className = asdf.join(" ") + " __mdfade_bottom_40";
	} else if (pct >= 0.3) {
		target.className = asdf.join(" ") + " __mdfade_bottom_30";
	} else if (pct >= 0.2) {
		target.className = asdf.join(" ") + " __mdfade_bottom_20";
	} else if (pct >= 0.1) {
		target.className = asdf.join(" ") + " __mdfade_bottom_10";
	} else if (pct < 0.1) {
		target.className = asdf.join(" ") + " __mdfade_bottom_0";
	}
}
